/* Combo Deal (statafelrok + topper): runtime (2026-NL design). Leest config-JSON (uit
   metaobjects): prijsblok boven de kleuren, sticky preview (rok-foto + topper-chip +
   "Jouw set"), stap 1 rokkleur, stap 2 optionele topper (toggle + "zelfde als rok"),
   voorkeur-combinaties, stap 3 aantal, live setprijs en verzendnudge.
   "In winkelwagen" voegt rok + (optioneel) topper toe als aparte regels (gedeelde _bundle). */
(function () {
  function euro(n) { return "€" + n.toFixed(2).replace(".", ","); }
  // Getal met enkel- of meervoud: "1 tafel", "2 tafels", zoals de sticky balk al deed.
  function aantal(n, enkel, meer) { return n + " " + (n === 1 ? enkel : meer); }

  function init(root) {
    var cfgEl = root.querySelector(".trc-config");
    if (!cfgEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(cfgEl.textContent); }
    catch (e) { console.error("[configurator] ongeldige config", e); return; }
    if (!CONFIG.groups || !CONFIG.groups.length) {
      console.warn("[configurator] geen groepen; staan de metaobjects op storefront PUBLIC_READ?");
      return;
    }

    var topperGroup = CONFIG.groups.filter(function (g) { return g.key === "topper"; })[0] || null;
    var rokGroup = CONFIG.groups.filter(function (g) { return g !== topperGroup; })[0] || CONFIG.groups[0];
    if (!topperGroup) topperGroup = CONFIG.groups[1] || null;
    var hasTopper = topperGroup && topperGroup !== rokGroup;

    // Combo Deal-korting op de complete set (alleen weergave; de echte korting is een
    // automatische korting in Shopify). Het bedrag is de enige schakelaar: 0 = niets tonen.
    var SET_DISC = parseFloat(String(CONFIG.setDiscount || "").replace(",", ".")) || 0;
    var DISC_LABEL = CONFIG.discountLabel || "Combo Deal-korting";
    // Bestellimiet per artikel (spiegel van de checkout-instelling); null = geen limiet.
    var ORDER_MAX = (typeof CONFIG.orderMax === "number" && CONFIG.orderMax > 0) ? CONFIG.orderMax : null;
    var CONTACT_URL = CONFIG.contactUrl || "/pages/contact";
    var CART_URL = CONFIG.cartUrl || "/cart";
    // Vanaf hoeveel resterende stuks noemen we het getal in de voorraadregel (zelfde drempel als de PDP).
    var VOORRAAD_DREMPEL = 5;

    function sw(c) { return c ? (c.swatch || c.img || "") : ""; }
    CONFIG.groups.forEach(function (g) {
      g.choices.forEach(function (c) { c.price = (c.priceCents || 0) / 100; });
    });
    function beschikbaar(c) { return !!c && c.available !== false; }
    // Standaardkeuze: de ingestelde default, tenzij die uitverkocht is; dan de eerste leverbare.
    function defChoice(g) {
      var d = g.choices.filter(function (c) { return c.kleur === g.default; })[0];
      if (beschikbaar(d)) return d;
      return g.choices.filter(beschikbaar)[0] || d || g.choices[0];
    }

    var sel = {};
    sel[rokGroup.key] = defChoice(rokGroup);
    if (hasTopper) sel[topperGroup.key] = defChoice(topperGroup);
    // Standaard de complete set tonen: Wit rok + Oranje topper (topper aan).
    var topperOn = hasTopper;

    // DOM-hooks
    var layerRok = root.querySelector(".trc-layer-rok");
    var layerTop = root.querySelector(".trc-layer-top");
    var dotRok = root.querySelector(".trc-dot-rok");
    var dotTop = root.querySelector(".trc-dot-top");
    var setRokName = root.querySelector(".trc-setrok-name");
    var setTopName = root.querySelector(".trc-settop-name");
    var setTopRow = root.querySelector(".trc-settop");
    var rokName = root.querySelector(".trc-rokname");
    var topName = root.querySelector(".trc-topname");
    var rokSwatches = root.querySelector(".trc-rok-swatches");
    var topSwatches = root.querySelector(".trc-top-swatches");
    var toggle = root.querySelector(".trc-toggle");
    var toggleLabel = root.querySelector(".trc-toggle-label");
    var topperBody = root.querySelector(".trc-topper-body");
    var sameBtn = root.querySelector(".trc-same");
    var combosStep = root.querySelector(".trc-combos-step");
    var combosBox = root.querySelector(".trc-combos");
    var pbWas = root.querySelector(".trc-price-was");
    var pbNow = root.querySelector(".trc-price-now");
    var pbBadge = root.querySelector(".trc-pricebox-badge");
    var pbSet = root.querySelector(".trc-pricebox-set");
    var pbShip = root.querySelector(".trc-pricebox-ship");
    var pbNote = root.querySelector(".trc-pricebox-note");
    var pbStock = root.querySelector(".trc-pricebox-stock");
    var pbStockTxt = root.querySelector(".trc-pricebox-stock-txt");
    // Verzenddag (F0025): "vandaag/morgen/maandag verzonden" komt uit snippets/verzenddag-2026nl,
    // die window.tr26Verzenddag inline vóór dit (deferred) script zet. Fallback: de tekst die
    // Liquid al in de regel zette, en pas daarna het oude vaste "vandaag verzonden".
    var verzenddagInit = (function () {
      var s = pbStockTxt && pbStockTxt.querySelector("[data-verzenddag]");
      return s ? s.textContent : "vandaag verzonden";
    })();
    function verzenddag() { return (window.tr26Verzenddag && window.tr26Verzenddag()) || verzenddagInit; }
    var pbTotal = root.querySelector(".trc-pricebox-total");
    var pbLimit = root.querySelector(".trc-pricebox-limit");
    var pbError = root.querySelector(".trc-pricebox-error");
    var sumRows = root.querySelector(".trc-sumrows");
    var totalEl = root.querySelector(".trc-total");
    var sUnit = root.querySelector(".trc-sticky-unit");
    var sQty = root.querySelector(".trc-sticky-qty");
    var qtyEl = root.querySelector(".trc-qty-input");
    var qtyUnit = root.querySelector(".trc-qty-unit");
    // Twee koopknoppen: in het prijsblok bovenaan en in de samenvatting/sticky balk onderaan.
    var addBtns = Array.prototype.slice.call(root.querySelectorAll(".trc-add"));
    addBtns.forEach(function (b) { b._label = b.innerHTML; });

    /* Verzendnudge: zelfde contract als de PDP (F0012): alles komt uit de
       data-attributen op de verzendregel. Staan die er niet (BE zonder drempel, klant met
       gratis-verzending-perk), dan blijft SHIP_THRESHOLD 0 en raakt update() de regel nooit
       aan. SHIP_BASE is render-time; wie de winkelwagen vult zonder deze pagina te herladen
       rekent tot de volgende paginalading met de oude baseline. */
    function attrCent(el, naam) { var n = el ? parseInt(el.getAttribute(naam), 10) : 0; return isNaN(n) ? 0 : n; }
    var SHIP_THRESHOLD = attrCent(pbShip, "data-threshold");
    var SHIP_BASE = attrCent(pbShip, "data-cart");
    var SHIP_COST = (pbShip && pbShip.getAttribute("data-shipcost")) || "";
    // De beginstand telt niet als omslag: pas een échte overgang naar gratis is nieuws.
    // Bij de eerste update() nemen we de stand over zonder te melden.
    var shipFreeGemeld = false;
    var shipEersteMeting = true;

    // Voorraadgrens van een keuze: getal, of null als er geen grens is.
    function keuzeMax(c) { return (c && typeof c.max === "number") ? c.max : null; }
    // Maximum voor de huidige set: de krapste van rok, (topper) en de bestellimiet. null = geen grens.
    function setMax() {
      var m = ORDER_MAX;
      var kandidaten = [keuzeMax(sel[rokGroup.key])];
      if (hasTopper && topperOn) kandidaten.push(keuzeMax(sel[topperGroup.key]));
      kandidaten.forEach(function (k) { if (k !== null && (m === null || k < m)) m = k; });
      return m;
    }
    // Welke helft is de krapste? Voor de melding ("Van Statafelrok Donker Rood kunnen we er nu maximaal 3 leveren").
    function krapsteKeuze() {
      var rok = sel[rokGroup.key], top = (hasTopper && topperOn) ? sel[topperGroup.key] : null;
      var rm = keuzeMax(rok), tm = keuzeMax(top);
      if (rm !== null && (tm === null || rm <= tm)) return { naam: "Statafelrok " + rok.kleur, max: rm };
      if (tm !== null) return { naam: "Topper " + top.kleur, max: tm };
      return null;
    }
    // Aantal, afgeklemd op het maximum. Bij max 0 blijft het veld op 1 staan (de melding legt uit waarom).
    function qty() {
      var n = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      var m = setMax();
      if (m !== null && m > 0 && n > m) n = m;
      return n;
    }
    var limietGewenst = false; // klant wilde boven het maximum: dan tonen we de regel
    function toonLimiet() {
      if (!pbLimit) return;
      var m = setMax();
      if (m === null || !limietGewenst) { pbLimit.hidden = true; return; }
      var k = krapsteKeuze();
      var contact = ' Meer nodig? <a href="' + CONTACT_URL + '">Neem contact op</a>.';
      var tekst;
      if (m === 0) tekst = "Meer hebben we er nu niet van deze kleur: wat we hadden ligt al in je winkelwagen." + contact;
      else if (k && k.max === m) tekst = "Van " + k.naam + " kunnen we er nu maximaal " + m + " leveren." + contact;
      else tekst = "Maximaal " + aantal(m, "stuk", "stuks") + " per bestelling." + contact;
      pbLimit.innerHTML = tekst;
      pbLimit.hidden = false;
    }
    function toonFout(html) { if (!pbError) return; pbError.innerHTML = html; pbError.hidden = false; }
    function verbergFout() { if (pbError && !pbError.hidden) pbError.hidden = true; }
    function dotStyle(el, choice) { if (el) el.style.backgroundImage = sw(choice) ? "url('" + sw(choice) + "')" : "none"; }
    function findChoice(group, kleur) {
      if (!group) return null;
      return group.choices.filter(function (c) { return c.kleur === kleur; })[0] || null;
    }
    // Tolerante variant (trim + case-insensitive): voor kleuren uit URL-params.
    function findChoiceCI(group, kleur) {
      if (!group || !kleur) return null;
      var key = String(kleur).trim().toLowerCase();
      return group.choices.filter(function (c) { return String(c.kleur).trim().toLowerCase() === key; })[0] || null;
    }
    // Voorselectie via ?rok=…&topper=… (bv. vanaf een PDP-Combo Deal-kaartje). Een kleur die
    // inmiddels uitverkocht is wordt NIET geselecteerd: dan blijft de standaardkleur staan
    // en zegt de melding in het prijsblok waarom (anders zag je pas bij "In winkelwagen"
    // dat de set niet kon).
    function applyUrlParams() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      var oos = [];
      var rokParam = params.get("rok");
      if (rokParam) {
        var rc = findChoiceCI(rokGroup, rokParam);
        if (rc && beschikbaar(rc)) sel[rokGroup.key] = rc;
        else if (rc) oos.push("Statafelrok " + rc.kleur);
      }
      var topParam = params.get("topper");
      if (topParam && hasTopper) {
        var tc = findChoiceCI(topperGroup, topParam);
        if (tc && beschikbaar(tc)) { sel[topperGroup.key] = tc; topperOn = true; }
        else if (tc) oos.push("Topper " + tc.kleur);
      }
      if (oos.length && pbNote) {
        pbNote.textContent = oos.join(" en ") + (oos.length > 1 ? " zijn" : " is") + " tijdelijk uitverkocht. We hebben een leverbare kleur voor je klaargezet; kies gerust een andere.";
        pbNote.hidden = false;
      }
    }
    function verbergNote() { if (pbNote && !pbNote.hidden) pbNote.hidden = true; }

    function buildSwatches(group, box) {
      if (!group || !box) return;
      group.choices.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        var oos = (c.available === false);
        b.className = oos ? "trc-sw trc-sw-oos" : "trc-sw";
        b.title = oos ? (c.kleur + " (niet op voorraad)") : c.kleur;
        b.setAttribute("aria-label", group.name + ": " + c.kleur + (oos ? " (niet op voorraad)" : ""));
        if (oos) { b.disabled = true; b.setAttribute("aria-disabled", "true"); }
        b.innerHTML = '<img src="' + sw(c) + '" alt="">';
        b._choice = c;
        b.addEventListener("click", function () {
          if (c.available === false) return;
          sel[group.key] = c;
          if (group === topperGroup) topperOn = true;
          verbergNote();
          update();
        });
        box.appendChild(b);
      });
    }

    function autoCombos() {
      if (!hasTopper) return [];
      var tops = topperGroup.choices;
      return rokGroup.choices.slice(0, 6).map(function (r, i) {
        var t = tops[i % tops.length] || tops[0];
        return { rok: r.kleur, topper: t ? t.kleur : "", label: r.kleur + (t ? " + " + t.kleur : "") };
      });
    }
    var combos = (CONFIG.presets && CONFIG.presets.length) ? CONFIG.presets : autoCombos();
    function buildCombos() {
      if (!combosStep || !combosBox || !combos.length) return;
      combosStep.hidden = false;
      combos.forEach(function (cb) {
        var r = findChoice(rokGroup, cb.rok);
        if (!r) return;
        var t = findChoice(topperGroup, cb.topper);
        var b = document.createElement("button");
        b.type = "button";
        // Een combinatie met een uitverkochte kleur blijft zichtbaar maar is niet te kiezen.
        var comboOos = !beschikbaar(r) || (t && !beschikbaar(t));
        b.className = comboOos ? "trc-combo trc-combo-oos" : "trc-combo";
        b.title = cb.label + (comboOos ? " (niet op voorraad)" : "");
        if (comboOos) { b.disabled = true; b.setAttribute("aria-disabled", "true"); }
        var thumb = '<span class="trc-combo-thumb"><img class="trc-combo-layer" src="' + (r.img || "") + '" alt="">';
        if (t && t.img) thumb += '<img class="trc-combo-layer" src="' + t.img + '" alt="">';
        thumb += '</span><span class="trc-combo-name">' + cb.label + "</span>";
        b.innerHTML = thumb;
        b._rok = r; b._top = t;
        b.addEventListener("click", function () {
          if (comboOos) return;
          sel[rokGroup.key] = r;
          if (t) { sel[topperGroup.key] = t; topperOn = true; }
          verbergNote();
          update();
        });
        combosBox.appendChild(b);
      });
    }

    function update() {
      var rok = sel[rokGroup.key];
      var top = hasTopper ? sel[topperGroup.key] : null;

      // Alt volgt de selectie: zonder beschrijvende alt is de preview onzichtbaar voor screenreaders en AI.
      if (layerRok) {
        layerRok.src = rok.img || "";
        layerRok.alt = "Voorbeeld: statafelrok in de kleur " + rok.kleur + " om een ronde statafel";
      }
      if (layerTop) {
        if (hasTopper && topperOn && top && top.img) {
          layerTop.src = top.img;
          layerTop.alt = "Voorbeeld: statafeltopper in de kleur " + top.kleur + " over de statafelrok";
          layerTop.hidden = false;
        }
        else { layerTop.hidden = true; }
      }
      dotStyle(dotRok, rok);
      if (setRokName) setRokName.textContent = "Statafelrok · " + rok.kleur;
      if (setTopRow) setTopRow.hidden = !(hasTopper && topperOn);
      if (hasTopper && topperOn) { dotStyle(dotTop, top); if (setTopName) setTopName.textContent = "Topper · " + top.kleur; }

      if (rokName) rokName.textContent = rok.kleur;
      if (hasTopper && top && topName) topName.textContent = top.kleur;

      if (toggle) toggle.setAttribute("aria-pressed", topperOn ? "true" : "false");
      if (toggleLabel) toggleLabel.textContent = topperOn ? "Topper toegevoegd" : "Geen topper";
      if (topperBody) topperBody.hidden = !topperOn;

      [rokSwatches, topSwatches].forEach(function (box) {
        if (!box) return;
        box.querySelectorAll(".trc-sw").forEach(function (b) {
          var on = (box === rokSwatches) ? (b._choice === rok) : (b._choice === top);
          b.classList.toggle("sel", !!on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
      });
      if (combosBox) combosBox.querySelectorAll(".trc-combo").forEach(function (b) {
        var on = b._rok === rok && (hasTopper && topperOn ? b._top === top : !b._top);
        b.classList.toggle("sel", !!on);
      });

      var isSet = hasTopper && topperOn;
      var unit = rok.price + (isSet ? top.price : 0);
      var disc = (isSet && SET_DISC > 0) ? Math.min(SET_DISC, unit) : 0;
      var unitNet = unit - disc;
      var total = unitNet * qty();
      if (sumRows) {
        var rows = '<div class="trc-sumrow"><span>Statafelrok · ' + rok.kleur + "</span><span>" + euro(rok.price) + "</span></div>";
        if (isSet) rows += '<div class="trc-sumrow"><span>Topper · ' + top.kleur + "</span><span>" + euro(top.price) + "</span></div>";
        if (disc > 0) rows += '<div class="trc-sumrow trc-sumrow-disc" style="color:#b8490d;"><span>' + DISC_LABEL + '</span><span>&minus;' + euro(disc) + "</span></div>";
        rows += '<div class="trc-sumrow trc-sumrow-unit"><span>Setprijs per tafel</span><span>' + (disc > 0 ? '<s style="color:#6f6a61;font-weight:500;">' + euro(unit) + "</s> " : "") + euro(unitNet) + "</span></div>";
        rows += '<div class="trc-sumrow trc-sumrow-total"><span class="trc-sumrow-k">Totaal · ' + aantal(qty(), "tafel", "tafels") + '</span><span class="trc-total-big">' + euro(total) + "</span></div>";
        sumRows.innerHTML = rows;
      }
      if (totalEl) totalEl.textContent = euro(total);
      // Sticky balk (mobiel): de losse prijs doorgestreept vóór de setprijs, zoals de PDP.
      if (sUnit) sUnit.innerHTML = (disc > 0 ? "<s>" + euro(unit) + "</s> " : "") + euro(unitNet);
      if (sQty) sQty.textContent = "Totaal · " + aantal(qty(), "tafel", "tafels");

      // Prijsblok boven de kleuren.
      if (pbWas) { pbWas.innerHTML = "<s>" + euro(unit) + "</s>"; pbWas.hidden = !(disc > 0); }
      if (pbNow) pbNow.textContent = euro(unitNet);
      if (pbBadge) {
        // Zonder topper is er geen set en dus geen voordeel: dan nodigt de badge ertoe uit.
        if (SET_DISC <= 0) { pbBadge.hidden = true; }
        else if (disc > 0) { pbBadge.hidden = false; pbBadge.textContent = "Je bespaart " + euro(disc) + " per set"; }
        else { pbBadge.hidden = false; pbBadge.textContent = "Voeg een topper toe en bespaar " + euro(SET_DISC); }
      }
      if (pbSet) pbSet.textContent = isSet
        ? "Statafelrok " + rok.kleur + " + Topper " + top.kleur
        : "Statafelrok " + rok.kleur;

      // Leverbaarheid van de huidige set: bepaalt voorraadregel én koopknoppen. Kan alleen
      // misgaan als ook de standaardkleur uitverkocht is of via een oude URL; de swatches
      // en combinaties laten een uitverkochte kleur zelf al niet meer kiezen.
      var leverbaar = beschikbaar(rok) && (!isSet || beschikbaar(top));
      if (pbStock) pbStock.classList.toggle("is-oos", !leverbaar);
      var m = setMax();
      var laag = leverbaar && m !== null && m > 0 && m <= VOORRAAD_DREMPEL && m !== ORDER_MAX;
      if (pbStockTxt) pbStockTxt.textContent = !leverbaar
        ? "Tijdelijk uitverkocht in deze kleur, kies een andere"
        : (laag ? "Nog " + m + " op voorraad \u00b7 " + verzenddag() : "Op voorraad \u00b7 " + verzenddag());
      // Na een kleurwissel kan het aantal boven het nieuwe maximum liggen: dan klemt qty() al af;
      // zet het veld gelijk en zeg waarom.
      if (m !== null && m > 0 && (parseInt(qtyEl.value, 10) || 1) > m) { qtyEl.value = String(m); limietGewenst = true; }
      toonLimiet();
      // Eenheid naast het aantalveld volgt het getal dat (na het afklemmen) in het veld staat.
      if (qtyUnit) qtyUnit.textContent = parseInt(qtyEl.value, 10) === 1 ? "tafel" : "tafels";
      if (pbTotal) {
        pbTotal.hidden = qty() < 2;
        pbTotal.textContent = "Totaal " + aantal(qty(), "tafel", "tafels") + ": " + euro(total);
      }
      addBtns.forEach(function (b) {
        if (b._bezig) return;
        b.disabled = !leverbaar;
        b.innerHTML = leverbaar ? b._label : "Niet leverbaar";
      });

      if (SHIP_THRESHOLD && pbShip) {
        var totaalCent = SHIP_BASE + Math.round(unitNet * 100) * qty();
        var gratis = totaalCent >= SHIP_THRESHOLD;
        pbShip.textContent = gratis
          ? "\u2713 Gratis verzending"
          : "Verzending \u20ac" + SHIP_COST + " \u00b7 nog " + euro((SHIP_THRESHOLD - totaalCent) / 100) + " tot gratis verzending";
        pbShip.style.color = gratis ? "#2c6b3a" : "";
        // Eén keer per pagina, zelfde dataLayer-conventie als assets/analytics-2026nl.js.
        if (shipEersteMeting) { shipEersteMeting = false; shipFreeGemeld = gratis; }
        else if (gratis && !shipFreeGemeld) {
          shipFreeGemeld = true;
          try { (window.dataLayer = window.dataLayer || []).push({ event: "configurator_free_shipping_reached" }); } catch (e) {}
        }
      }
    }

    if (toggle) toggle.addEventListener("click", function () { topperOn = !topperOn; update(); });
    if (sameBtn) sameBtn.addEventListener("click", function () {
      var match = findChoice(topperGroup, sel[rokGroup.key].kleur);
      if (beschikbaar(match)) { sel[topperGroup.key] = match; topperOn = true; verbergNote(); update(); }
    });
    root.querySelector(".trc-minus").addEventListener("click", function () { limietGewenst = false; qtyEl.value = String(Math.max(1, qty() - 1)); update(); });
    root.querySelector(".trc-plus").addEventListener("click", function () {
      var m = setMax();
      if (m !== null && qty() + 1 > m) { limietGewenst = true; qtyEl.value = String(qty()); update(); return; }
      qtyEl.value = String(qty() + 1); update();
    });
    // Tijdens typen niet afronden (het getal zou onder je handen wegspringen); wel bij verlaten van het veld.
    qtyEl.addEventListener("input", function () {
      var m = setMax(), n = parseInt(qtyEl.value, 10) || 0;
      limietGewenst = (m !== null && n > m);
      update();
    });
    qtyEl.addEventListener("change", function () { qtyEl.value = String(qty()); update(); });

    function voegToe(btn) {
      var rok = sel[rokGroup.key];
      var isSet = hasTopper && topperOn;
      if (!beschikbaar(rok) || (isSet && !beschikbaar(sel[topperGroup.key]))) return;
      var bundleId = "trc-" + Date.now() + "-" + Math.floor(Math.random() * 1e6);
      var items = [];
      var rokProps = { _bundle: bundleId }; rokProps[rokGroup.name] = rok.kleur;
      items.push({ id: Number(rok.variantId), quantity: qty(), properties: rokProps });
      if (isSet) {
        var top = sel[topperGroup.key];
        var topProps = { _bundle: bundleId }; topProps[topperGroup.name] = top.kleur;
        items.push({ id: Number(top.variantId), quantity: qty(), properties: topProps });
      }
      verbergFout();
      addBtns.forEach(function (b) { b._bezig = true; b.disabled = true; b.textContent = "Bezig\u2026"; });
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (r.ok) return r.json();
          // 422 = Shopify heeft afgeklemd (voorraad of bestellimiet) en legt in `description` uit
          // wat er wél is toegevoegd. Die tekst tonen we, mét de weg naar de winkelwagen.
          return r.json().then(function (j) { throw { status: r.status, description: j && (j.description || j.message) }; },
                               function () { throw { status: r.status }; });
        })
        .then(function () { window.location.href = CART_URL; })
        .catch(function (err) {
          console.error("[configurator] add to cart faalde", err);
          addBtns.forEach(function (b) { b._bezig = false; b.disabled = false; b.innerHTML = b._label; });
          var esc = function (t) { return String(t).replace(/[&<>"]/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]; }); };
          if (err && err.status === 422 && err.description) {
            toonFout("<strong>Dat lukte niet helemaal.</strong> " + esc(err.description) +
              ' <a href="' + CART_URL + '">Bekijk je winkelwagen</a> of pas het aantal aan. Meer nodig? <a href="' + CONTACT_URL + '">Neem contact op</a>.');
          } else {
            toonFout("<strong>Toevoegen aan de winkelwagen is niet gelukt.</strong> Probeer het nog eens; blijft het misgaan, <a href=\"" + CONTACT_URL + "\">neem dan contact op</a>.");
          }
        });
    }
    addBtns.forEach(function (b) { b.addEventListener("click", function () { voegToe(b); }); });

    buildSwatches(rokGroup, rokSwatches);
    if (hasTopper) buildSwatches(topperGroup, topSwatches);
    buildCombos();
    applyUrlParams();
    update();
  }

  function boot() { document.querySelectorAll("[data-trc]").forEach(init); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
